import { Button } from '@thanx/uikit/button'
import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'

import { buildTranslate } from 'locales'

type ModifierToggleProps = {
  children: React.ReactNode
  isVisible: boolean
  setIsVisible: (visible: boolean) => void
  isButtonDisabled?: boolean
}

const t = buildTranslate('redeem_manager.modifier_select.wrapper')

const ModifierToggle = ({
  isVisible,
  setIsVisible,
  children,
  isButtonDisabled = false,
}: ModifierToggleProps) => {
  const [css] = useStyletron()

  const toggleVisibility = () => setIsVisible(!isVisible)

  return (
    <>
      <Switch condition={!isVisible}>
        <Button
          kind="secondary"
          onClick={toggleVisibility}
          disabled={isButtonDisabled}
          aria-expanded={isVisible}
          aria-controls="modifier-content"
          className={`${css({
            width: 'fit-content',
          })} mr-s mt-m mb-s mb-sm-0`}
        >
          {t('display')}
        </Button>
      </Switch>
      <Switch condition={isVisible}>{children}</Switch>
    </>
  )
}

export default ModifierToggle
